import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PASS_THROUGH } from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentDateWithUtcOffset on DateWithUtcOffset {
    date
    utcOffset
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentDateWithUtcOffsetFragment,
  ents.core.common.DateWithUtcOffset
>({
  date: graphql.transformers.OUT.validate(
    graphql.transformers.AWS_SCALARS.datetime,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  utcOffset: PASS_THROUGH,
})
